import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6c01a500&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=6c01a500&scoped=true&lang=css"
import style1 from "./index.vue?vue&type=style&index=1&id=6c01a500&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c01a500",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c01a500')) {
      api.createRecord('6c01a500', component.options)
    } else {
      api.reload('6c01a500', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6c01a500&scoped=true", function () {
      api.rerender('6c01a500', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/businessHome/components/KpUserWrap/index.vue"
export default component.exports